<script>
// Components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import ModalMedia from '@/components/widgets/modalMedia'
import UserProfile from "@/router/views/users/user-profile"

// Services
import MediaDataService from "@/services/MediaDataService";
import UsersDataService from "@/services/UsersDataService";

// Helpers
import Storage from "@/helpers/storage";
import UserUtils from '@/helpers/users'
import {authComputed} from "@/state/helpers";
import DateUtils from '@/helpers/date';
import AdminUtils from '@/helpers/admin';

// External Components
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import isEmpty from "is-empty";
import imageCompression from 'browser-image-compression';
import { PinturaEditorModal } from '@pqina/vue-pintura/vue-2';
import {
  // editor
  createDefaultImageReader,
  createDefaultImageWriter,
  createDefaultImageScrambler,
  createDefaultShapePreprocessor,

  // plugins
  setPlugins,
  plugin_crop,
  plugin_filter,
  plugin_filter_defaults,
  plugin_finetune,
  plugin_finetune_defaults,
  markup_editor_defaults,
  plugin_redact,
} from '@pqina/pintura';

import locale_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/core/fr_FR.js';

// each plugin has a separate locale file
import locale_crop_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/crop/fr_FR.js';
import locale_redact_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/redact/fr_FR.js';
import locale_filter_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/filter/fr_FR.js';
import locale_finetune_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/finetune/fr_FR.js';
import StorageUtils from "../../../helpers/storage";

const localeEditor = {
  ...locale_fr_FR,
  ...locale_crop_fr_FR,
  ...locale_redact_fr_FR,
  ...locale_filter_fr_FR,
  ...locale_finetune_fr_FR,
};

localeEditor.redactLabel = "Censurer";


setPlugins(plugin_crop, plugin_finetune, plugin_filter, plugin_redact);

export default {
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Users Medias",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    CoolLightBox,
    DatePicker,
    ModalMedia,
    VueTabs,
    VTab,
    UserProfile,
    PinturaEditorModal,
  },

  computed: {
    ...authComputed
  },

  methods: {
    ...UserUtils,
    ...DateUtils,

    getRequestParams(page, pageSize) {
      let params = {};
      params["page"] = page - 1;
      params["size"] = pageSize;
      params["filtersType"] = this.filtersType.selected;
      params["filtersGender"] = this.filtersGender.selected;
      params["filtersMediaScore"] = this.filtersMediaScore.selected;
      params["filtersMediaType"] = this.filtersMediaType.selected;
      params["filtersStatus"] = this.filtersChecked.selected;
      params['filtersCountry'] = this.filtersCountry.selected;

      if (this.filtersDates.selected === 'custom' && this.filtersDates.dateRange !== null) {
        this.filtersDates.fromDate = this.$moment(this.filtersDates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersDates.toDate = this.$moment(this.filtersDates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }

      params["fromDate"] = this.filtersDates.fromDate || '';
      params["toDate"] = this.filtersDates.toDate || '';

      return params;
    },

    handlePageChange(value) {
      this.page = value;
      this.loadMedia();
    },

    handleDisplayChange() {
      this.page = 1;
      this.loadMedia();
    },

    getImage(userId, mediaId, elt) {
      return Storage.getUserMedia(userId, mediaId, elt);
    },

    loadMedia() {
      if (this.isSearching)
        return;

      this.isSearching = true;

      const params = this.getRequestParams(
          this.page,
          this.pageSizes.selected
      );
      if (this.media.length > 0) {
        this.deleteItems();
        this.imagesCount = 0;
      }

      MediaDataService.getAll(params)
        .then(response => {
          const { items, totalItems } = response.data;
          if (items.length > 0) {
            items.forEach(item => {
              item.src = '';
              item.thumb = '';
              item.title =  new Date(item.createdAt).toLocaleString()+ " - media #"+item.rankMedia;
              item.description = item.name + ' #'+item.userId;
              item.isVideo = item.typeMedia === 1;
              this._loadMedia(item);
            });
          }
          this.count = totalItems;
          this.isSearching = false;
          //this.$refs.waterfall.waterfallOver();
        })
        .catch(e => {
          this.isSearching = false;
          window.console.error("loadMedia failed...", e);
        })
    },

    _loadMedia(item) {

      const promises = [];

      if (!item.isVideo) {
        if (item.isValid) {
          promises.push(Storage.getUserMediaUrl(item.userId, item.mediaId));
        } else {
          promises.push(Storage.getUserMediaUrl(item.userId, item.mediaId+'.origin'));
        }
      }
      else if (item.isVideo) {
        promises.push(Storage.getUserMediaUrl(item.userId, item.thumbFileName));
        promises.push(Storage.getUserMediaUrl(item.userId, item.mediaId));
      }

      const that = this;
      Promise.all(promises)
          .then(values => {
            if (values.length === 1) {
              item.thumb = item.src = values[0];
            } else {
              item.thumb = values[0];
              item.src = values[1];
            }

            let img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = function() {
              item.width = img.width;
              item.height = img.height;
              item.imgObj = img;
              that.media.push(item);
            };
            img.src = item.thumb;
          })
        .catch (error => {
          window.console.error(error);
          let img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = function() {
            item.width = img.width;
            item.height = img.height;
            item.imgObj = img;
            that.media.push(item);
          };
          img.src = require("@/assets/images/users/error.png");
        });
    },

    closeModal() {
      this.$refs.mediaModal.closeModal();
    },

    markAsVerified(media) {
      const params = {
        userId: media.userId,
        adminId: this.getUser.uid,
        score: media.mediaScore
      };

      let parent = document.getElementById(media.mediaId);
      let loadingElt = parent.getElementsByClassName('media-item-loading')[0];
      loadingElt.classList.toggle('d-none');
      return MediaDataService
          .markAsVerified(media.mediaId, params)
          .then(() => {
            loadingElt.classList.toggle('d-none');
            media.checked = '1';
            media.checkedAt = new Date().toISOString().slice(0, 19).replace('T', ' ');
            media.mediaScoreAt = new Date().toISOString().slice(0, 19).replace('T', ' ');
            media.checkedBy = this.getUser.displayName;
            media.mediaScoreBy = this.getUser.displayName;
            if (this.filtersChecked.selected === 'N') {
              this.count--;
              let idx = this.media.findIndex(m => m.mediaId === media.mediaId);
              if (idx >= 0) this.media.splice(idx, 1);
              this.resizeAllMasonryItems();
            }
          })
          .catch((error) => {
            loadingElt.classList.toggle('d-none');
            this.$toast.error(error.toString());
            window.console.error(error);
          });
    },

    mediaClick(value, index) {
      //if (this.media[index].isValid)
        this.indexMedia = index;
    },

    editClick(value, index) {
      this.editor.media = this.media[index];
      this.editor.visible = true;
    },

    rendered (mediaId) {
      this.imagesCount++

      let elt = document.getElementById(mediaId).parentNode;
      this.resizeMasonryItem(elt);
    },

    renderedError () {
      this.imagesCount++
    },

    resizeMasonryItem (item) {
      /* Get the grid object, its row-gap, and the size of its implicit rows */
      let grid = document.getElementsByClassName('masonry')[0],
          rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
          rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));

      /*
       * Spanning for any brick = S
       * Grid's row-gap = G
       * Size of grid's implicitly create row-track = R
       * Height of item content = H
       * Net height of the item = H1 = H + G
       * Net height of the implicit row-track = T = G + R
       * S = H1 / T
       */

      let rowSpan = Math.ceil((item.querySelector('.media-item-content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));

      /* Set the spanning as calculated above (S) */
      item.style.gridRowEnd = 'span ' + rowSpan;
    },

    deleteItems() {
      document.querySelectorAll('.media-item').forEach(elt => {
        elt.remove();
      });
      this.media.splice(0, this.media.length);
    },

    resizeAllMasonryItems () {
      // Get all item class objects in one list
      let allItems = document.getElementsByClassName('media-item');
      /*
       * Loop through the above list and execute the spanning function to
       * each list-item (i.e. each masonry item)
       */
      for (let i = 0; i < allItems.length; i++) {
        this.resizeMasonryItem(allItems[i]);
      }
    },

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filtersDates.selected) {
        case "always":
          this.filtersDates.fromDate = null;
          this.filtersDates.toDate = null;
          break;
        case "today":
          this.filtersDates.fromDate = now.format('YYYY-MM-DD');
          this.filtersDates.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersDates.toDate = now.format('YYYY-MM-DD');
          this.filtersDates.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersDates.toDate = now.format('YYYY-MM-DD');
          this.filtersDates.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersDates.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersDates.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersDates.toDate = now.subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          this.filtersDates.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersDates.toDate = now.format('YYYY-MM-DD');
          this.filtersDates.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersDates.fromDate = null;
          this.filtersDates.toDate = null;
          break;
      }
      if (this.filtersDates.selected !== "custom") {
        this.filtersDates.dateRange = null;
      }
    },

    openUserPane() {
      if (!this.isUserPaneDisplayed) {
        this.isUserPaneDisplayed = true;
      }
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(obj) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(user => user.userId === obj.userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(obj.userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+obj.userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== obj.userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = obj.userId; }, 100);
      }
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    },

    handleEditModalShow() {
      window.console.log("handleEditModalShow");
    },

    handleEditModalClose() {
      window.console.log("handleEditModalClose");
    },

    handleEditModalLoad(event) {
      window.console.log("handleEditModalLoad");
      window.console.log(event);
    },

    handleCompressMedia(progress) {
      this.editor.progressCompress = progress;
      // window.console.log(`handleCompressMedia ${progress}`);
    },

    async compressMedia(file, options) {
      try {
        this.editor.progressCompress = 0;
        const compressedFile = await imageCompression(file, options);
        window.console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
        window.console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
        this.editor.progressCompress = 100;
        return compressedFile;
      } catch (error) {
        window.console.error(error);
        this.editor.progressCompress = 100;
        return null;
      }
    },

    async handleEditModalProcess(event) {
      window.console.log("handleEditModalProcess");
      window.console.log(event);
      this.$refs.mediaModal.openModal();
      this.editor.processing = true;
      this.editor.processingType = "compress";
      let compressedFile = await this.compressMedia(event.dest, {
        fileType: 'image/jpeg',
        alwaysKeepResolution: true,
        onProgress: this.handleCompressMedia
      });

      if (compressedFile === null) {
        compressedFile = event.dest;
      }

      const reader = new FileReader();
      reader.addEventListener('load', () => {
        window.console.log("readAsDataURL ready");
        this.validEditMedia(reader.result);
      });
      reader.addEventListener('error', () => {
        window.console.error(reader.error);
      });
      reader.readAsDataURL(compressedFile);
    },

    validEditMedia(dataUrl) {
      const img  = new Image();
      img.addEventListener("load", async () => {
        window.console.log("image dataUrl loaded");
        this.editor.result.width = img.width;
        this.editor.result.height = img.height;
        this.editor.processingType = "upload";
        await UserUtils.deleteOldMediaBeforeReupload(this.editor.media.userId, this.editor.media);
        const uploadTask = StorageUtils.uploadMediaFromDataURL(this.editor.media.userId, this.editor.media.mediaId, dataUrl);
        uploadTask.on('state_changed',
            (snapshot) => {
              // Observe state change events such as progress, pause, and resume
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              this.editor.progressUpload = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            },
            (error) => {
              window.console.error("uploadMediaFromDataURL error", error);
              this.closeModal();
              this.$toast.error(error.message);
            },
            async () => {
              window.console.log("uploadMediaFromDataURL success");
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              try {
                this.editor.progressUpload = 100;
                await AdminUtils.addAction({
                  adminId: this.getUser.uid,
                  category: 'media',
                  type: 'transform',
                  userId: this.editor.media.userId,
                  data1: this.editor.media.mediaId
                });

                let idx = this.media.findIndex(m => m.mediaId === this.editor.media.mediaId);
                this.$toast.success(this.$t('media.media_transform_success'));
                if (this.filtersType.selected === 'I') {
                  this.count--;
                  if (idx > -1) this.media.splice(idx, 1);
                  this.resizeAllMasonryItems();
                } else {
                  this.media[idx].isValid = true;
                  this.media[idx].width = this.editor.result.width;
                  this.media[idx].height = this.editor.result.height;
                  this.editor.processingType = "refresh";
                  await this.reloadImg(this.media[idx].src);
                }

                MediaDataService.generateFaceThumbnail({
                      mediaId: this.editor.media.mediaId,
                      userId: this.editor.media.userId,
                    })
                    .then(response => {
                      const {urls} = response.data;
                      this.editor.processingType = "thumbnail";
                      this.editor.thumbnailNew = urls.new;
                      this.editor.thumbnailOld = urls.old;
                    })
                    .catch(error => {
                      window.console.error(error);
                      this.$toast.error("Generate new Thumbnail failed !");
                      this.finishEdit();
                    });
              }
              catch (error) {
                window.console.error("upload-success error", error);
              }
            }
        );
      });
      img.src = dataUrl;
    },

    async reloadImg(url) {
      await fetch(url, { cache: 'reload', mode: 'no-cors' })
      document.body.querySelectorAll(`img[src='${url}']`)
          .forEach(img => img.src = url)
    },

    finishEdit() {
      this.editor.processing = false;
      this.editor.processingType = "";
      this.editor.media = null;
      this.editor.thumbnailOld = "";
      this.editor.thumbnailNew = "";
      this.closeModal();
    },

    keepNewMediaThumb() {
      MediaDataService.keepNewThumbnail({
        userId: this.editor.media.userId,
        mediaId: this.editor.media.mediaId,
      })
      .then(() => {
        window.console.log("Old Thumbnail deleted");
        this.finishEdit();
      })
      .catch((error) => {
        window.console.error("Old Thumbnail removing failed", error);
        this.finishEdit();
      });
    },

    keepOldMediaThumb() {
      this.editor.processingType = "keep";
      MediaDataService.keepOldThumbnail({
          mediaId: this.editor.media.mediaId,
          userId: this.editor.media.userId,
        })
        .then(() => {
          this.this.finishEdit();
        })
        .catch((error) => {
          window.console.error(error);
          this.$toast.error("Keep old thumbnail failed !");
          this.finishEdit();
        })
    },

    validMedia(media) {
      let parent = document.getElementById(media.mediaId);
      let loadingElt = parent.getElementsByClassName('media-item-loading')[0];
      loadingElt.classList.toggle('d-none');
      UserUtils.validMedia(media.userId, media)
      .then(async () => {
        await AdminUtils.addAction({
          adminId: this.getUser.uid,
          category: 'media',
          type: 'valid',
          userId: media.userId,
          data1: media.mediaId
        });
        loadingElt.classList.toggle('d-none');
        this.$toast.success(this.$t('media.media_valid_success'));
        media.isValid = true;
        if (this.filtersType.selected === 'I') {
          this.count--;
          let idx = this.media.findIndex(m => m.mediaId === media.mediaId);
          if (idx > -1) this.media.splice(idx, 1);
          this.resizeAllMasonryItems();
        }
        this.closeModal();
      })
      .catch(error => {
        loadingElt.classList.toggle('d-none');
        window.console.error("UserUtils.validMedia", media, error);
        this.$toast.error(error);
      })
    },

    async deleteMedia(media) {
      let parent = document.getElementById(media.mediaId);
      let loadingElt = parent.getElementsByClassName('media-item-loading')[0];
      loadingElt.classList.toggle('d-none');

      await MediaDataService.archiveMedia({
        userId: media.userId,
        mediaId: media.mediaId,
        adminId: this.getUser.uid,
      });

      UserUtils.deleteMedia(media.userId, media)
        .then(async () => {
          await AdminUtils.addAction({
            adminId: this.getUser.uid,
            category: 'media',
            type: 'delete',
            userId: media.userId,
            data1: media.mediaId
          });
          this.count--;
          loadingElt.classList.toggle('d-none');
          this.$toast.success(this.$t('media.media_delete_success'));
          let idx = this.media.findIndex(m => m.mediaId === media.mediaId);
          if (idx > -1) this.media.splice(idx, 1);

          // reset media rank for user
          const userMedia = this.media.filter(m => m.userId === media.userId);
          if (!isEmpty(userMedia)) {
            userMedia.forEach(elt => {
              if (elt.rankMedia > media.rankMedia && elt.rankMedia > 1)
                elt.rankMedia--;
            });
          }
          this.closeModal();
          this.resizeAllMasonryItems();
        })
      .catch(error => {
        loadingElt.classList.toggle('d-none');
        window.console.error("UserUtils.deleteMedia", media, error);
        this.$toast.error(error);
      })
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },
  },

  data() {
    return {
      userMedia: {
        media: [],
        index: -1
      },
      isSearching: false,
      media: [],
      indexMedia: null,
      userTabs:[],
      userTabsActive: '',
      isUserPaneDisplayed: false,
      imagesCount: 0,
      page: 1,
      count: 0,
      title: this.$t("menuitems.members.media"),
      pageSizes: {
        options: ['50', '100', '200'],
        selected: '50'
      },
      mediaOptionsImage: [
        {text: '🤢 BAD', value: "L"},
        {text: '🙂 MOY', value: "M"},
        {text: '🤩 TOP', value: "H"},
      ],
      mediaOptionsVideo: [
        {text: 'normal', value: "M"},
        {text: 'featured', value: "H"},
      ],
      filtersType: {
        selected: 'A',
        options: [
            'A', 'I'
        ]
      },
      filtersChecked: {
        selected: 'N',
        options: [
          'A', 'C', 'N'
        ]
      },
      filtersMediaType: {
        selected: 'A',
        options: [
          'P', 'V', 'A'
        ]
      },
      filtersCountry: {
        selected: 'all',
        options: [
          {value: 'all', text: 'All Countries'},
          {value: 'FR', text: 'FR - France'},
          {value: 'BE', text: 'BE - Belgium'},
          {value: 'CH', text: 'CH - Switzerland'},
          {value: 'CA', text: 'CA - Canada'},
          {value: '', text: '----------------'},
          {value: 'others', text: 'Others'},
        ]
      },
      filtersGender: {
        selected: '',
        options: [
          '', 'M', 'F'
        ]
      },
      filtersMediaScore: {
        selected: '',
        options: [
          {value: '', label: 'All Score'},
          {value: 'L', label: '🤢 BAD'},
          {value: 'M', label: '🙂 MOY'},
          {value: 'H', label: '🤩 TOP'},
        ],
      },
      filtersDates: {
        dateRange: null,
        selected: 'always',
        fromDate: null,
        toDate: null,
        options: [
          {value:'today', text:this.$t("dates.today")},
          {value:'yesterday', text:this.$t("dates.yesterday")},
          {value:'curMonth', text:this.$t("dates.curMonth")},
          {value:'lastMonth', text:this.$t("dates.lastMonth")},
          {value:'last3Month', text:this.$t("dates.last3Month")},
          {value:'curYear', text:this.$t("dates.curYear")},
          {value:'always', text:this.$t("dates.always")},
          {value:'custom', text:this.$t("dates.custom")}
        ]
      },
      editor: {
        // defaults
        editorProps: {
          imageReader: createDefaultImageReader(),
          imageWriter: createDefaultImageWriter(),
          shapePreprocessor: createDefaultShapePreprocessor(),

          ...plugin_finetune_defaults,
          ...plugin_filter_defaults,
          ...markup_editor_defaults,

          locale: localeEditor,
        },

        imageScrambler: createDefaultImageScrambler({ scrambleAmount: 5 }),
        media: null,
        visible: false,
        processing: false,
        processingType: "",
        progressUpload: 0,
        progressCompress: 0,
        thumbnailNew: "",
        thumbnailOld: "",
        result: {
          width: 100,
          height:200,
        }
      }
    }
  },

  mounted() {
    this.loadMedia();
  },

  created () {
    let masonryEvents = ['load', 'resize'];
    let vm = this
    masonryEvents.forEach(function (event) {
      window.addEventListener(event, vm.resizeAllMasonryItems);
    });
  },
  watch: {
    imagesCount: function () {
      if(this.imagesCount === this.media.length) {
        this.resizeAllMasonryItems()
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">

      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- filters -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body row">
              <b-form-row>
                <b-select :disabled="isSearching" class="form-select w-auto ms-2" v-model="filtersCountry.selected">
                  <option v-for="country in filtersCountry.options" :key="country.value" :value="country.value">{{ country.text }}</option>
                </b-select>
                <b-select :disabled="isSearching" class="form-select w-auto ms-2" v-model="filtersMediaType.selected">
                  <option v-for="mediaType in filtersMediaType.options" :key="mediaType" :value="mediaType">{{ $t('media.filters_media_type'+mediaType) }}</option>
                </b-select>
                <b-select :disabled="isSearching" class="form-select w-auto ms-2" v-model="filtersType.selected">
                  <option v-for="type in filtersType.options" :key="type" :value="type">{{ $t('media.filters_type'+type) }}</option>
                </b-select>
                <b-select :disabled="isSearching" class="form-select w-auto ms-2" v-model="filtersChecked.selected">
                  <option v-for="status in filtersChecked.options" :key="status" :value="status">{{ $t('media.filters_checked'+status) }}</option>
                </b-select>
                <b-select :disabled="isSearching" class="form-select w-auto ms-2" v-model="filtersGender.selected">
                  <option v-for="gender in filtersGender.options" :key="gender" :value="gender">{{ $t('media.filters_gender'+gender) }}</option>
                </b-select>
                <b-select
                    :disabled="isSearching"
                    class="form-select w-auto ms-2"
                    v-model="filtersMediaScore.selected"
                >
                  <option v-for="mediaScore in filtersMediaScore.options" :key="mediaScore.label" :value="mediaScore.value">{{ mediaScore.label }}</option>
                </b-select>
                <b-form-select
                    :id="'addSinceMedia'"
                    :disabled="isSearching"
                    @change="handleDateChange"
                    v-model="filtersDates.selected"
                    class="form-select d-inline w-auto ms-2"
                    :options="filtersDates.options">
                </b-form-select>
                 <div class="w-auto ms-2" style="min-width:220px;" v-show="this.filtersDates.selected === 'custom'">
                  <date-picker
                      :lang="page.localePicker"
                      :placeholder="this.$t('choose_date_interval')"
                      type="date"
                      :disabled="isSearching"
                      value-type="format"
                      show-week-number
                      v-model="filtersDates.dateRange"
                      @change="handleDateChange"
                      range append-to-body ></date-picker>
                </div>

                <b-button variant="primary" v-show="!isSearching" class="w-md ms-2" @click="loadMedia">{{ $t("find") }}</b-button>

                <div class="status ms-3" v-show="isSearching">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>

              </b-form-row>
            </div>
          </div>
        </div>
      </div>

      <!-- Top list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>

          <i class="fas fa-images"></i> {{ count }} media
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="leads-list"
            ></b-pagination>
          </div>
        </div>
      </div>

      <!-- result -->
      <div class="row">
        <div class="col-12">
          <div class="masonry">
            <div v-for="(item, key) in media"
                 :key="key"
                 class="media-item">
              <div class="media-item-content " :id="item.mediaId">
                <div class="text-white p-1 font-size-11" :class="item.sex === 1 ? 'bg-info' : 'bg-female'" @click="showUser({userId: item.userId, name: item.name})">
                  <country-flag
                      v-show="item.country != null && item.country !== '' "
                      :country="item.country"
                      size="small"
                      class="float-end"
                      :title="item.country"
                  />
                  {{ item.name }}, {{ getAge(item.birth) }}
                </div>
                <div class="position-relative">
                  <img :src="item.thumb" class="media-thumb" @error="renderedError()" @load="rendered(`${item.mediaId}`)" @click="mediaClick(item, key)" />
                  <div class="position-absolute top-0 w-100">
                    <div class="p-2 text-white text-center font-size-11" style="background:rgba(0, 0, 0, 0.5);" v-show="item.checked === '1'">
                      <i class="bx bx-check text-white"></i> {{ formatDate(item.checkedAt) }} - <b>{{ getInitials(item.checkedBy) }}</b>
                      <span class="d-block" v-show="item.mediaScore !== 'W' && item.mediaScoreAt !== '' && item.mediaScoreBy !== item.checkedBy">
                        <i class="bx bx-check text-white"></i> {{ formatDate(item.mediaScoreAt) }} - <b>{{ getInitials(item.mediaScoreBy) }}</b>
                      </span>
                    </div>
                    <div class="float-end m-1">
                      <span class="text-secondary font-size-11 d-inline-block rounded-circle shadow p-1 bg-white">
                      #{{ item.rankMedia }}
                      </span>
                      <span v-if="item.isVideo" class="text-secondary ms-1 d-inline-block rounded-circle shadow p-1 bg-white">
                        <img :src="require('@/assets/images/video-play.svg')" width="20"  />
                      </span>
                    </div>
                  </div>
                </div>
                <div class="p-2" :class="!item.isValid ? 'bg-danger' : 'bg-white'">
                  <div class="d-flex justify-content-center mt-1" v-show="item.isValid">
                    <b-form-group
                        label="Score ranking"
                        v-slot="{ ariaDescribedby }"
                    >
                      <b-form-radio-group
                          v-model="item.mediaScore"
                          :options="item.isVideo ? mediaOptionsVideo : mediaOptionsImage"
                          button-variant="outline-primary"
                          name="radio-btn-outline"
                          buttons
                      ></b-form-radio-group>
                    </b-form-group>
                  </div>

                  <div class="d-flex justify-content-center mt-1">
                    <b-button v-show="item.checked === '0'" class="rounded-circle ms-2" variant="primary" @click="markAsVerified(item)">
                      <b-icon icon="check" scale="1.5"></b-icon>
                    </b-button>
                    <b-button class="rounded-circle ms-2 me-2 bg-white" variant="outline-danger" @click="deleteMedia(item)">
                      <b-icon icon="x" scale="1.5"></b-icon>
                    </b-button>
                    <!--<b-button class="rounded-circle ms-2 me-2 bg-white" variant="outline-secondary" @click="showUser({userId: item.userId, name: item.name})">
                      <b-icon icon="search" scale="1"></b-icon>
                    </b-button>-->
                    <b-button v-show="!item.isVideo" class="rounded-circle ms-2 me-2" variant="outline-secondary" @click="editClick(item, key)">
                      <b-icon icon="pencil-fill" scale="1"></b-icon>
                    </b-button>
                    <b-button v-show="!item.isValid" class="rounded-circle ms-2" variant="success" @click="validMedia(item)">
                      <b-icon icon="check" scale="1.5"></b-icon>
                    </b-button>
                  </div>
                </div>

                <div class="p-2 bg-light text-center text-muted font-size-10">
                  #<b>{{ item.mediaId }}</b>
                </div>
                <div class="media-item-loading d-none"><i class="bx bx-loader-circle bx-spin"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="leads-list"
            ></b-pagination>
          </div>
        </div>
      </div>


    </div>

    <b-sidebar
        id="sidebar-right" right
        v-model="isUserPaneDisplayed"
    >
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia"
              >
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <!-- lightshow results -->
    <CoolLightBox
        :items="media"
        :index="indexMedia"
        :effect="'fade'"
        @close="indexMedia = null">
    </CoolLightBox>

    <!-- lightshow user -->
    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>

    <!-- Edit Image -->
    <PinturaEditorModal
        v-bind="editor.editorProps"
        v-if="editor.visible"
        :src="editor.media.src"
        :imageScrambler="editor.imageScrambler"
        :cropEnableButtonFlipVertical="true"
        :cropEnableButtonRotateRight="true"
        :cropEnableInfoIndicator="true"
        cropInteractionFocus="selection"

        @pintura:hide="editor.visible = false"
        @pintura:show="handleEditModalShow()"
        @pintura:close="handleEditModalClose()"
        @pintura:load="handleEditModalLoad($event)"
        @pintura:process="handleEditModalProcess($event)"
    />

    <!-- Modal Media popup -->
    <modalMedia ref="mediaModal">
      <template v-slot:body>
        <div v-show="editor.processing" class="card" style="min-width: 250px;min-height: 200px">
          <h5 class="p-5 text-center text-primary">Processing <span>{{ editor.processingType }}</span></h5>
          <div class="modalValidLoading" v-show="editor.processingType === 'keep'">
            <vue-ellipse-progress
                :loading="editor.processingType === 'keep'"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#fff"
                :size="70"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>
          <div class="" v-show="editor.processingType === 'thumbnail' ">
            <div class="row card-body">
              <div class="col-lg-6 col-12  text-center align-content-center">
                <p>OLD</p>
                <img :src="editor.thumbnailOld" width="150" height="150" />
                <br>
                <b-button
                    class="mt-2"
                    @click="keepOldMediaThumb"
                    variant="outline-danger">
                     {{ $t("media.keep_old_thumb") }}
                </b-button>
              </div>
              <div class="col-lg-6 col-12 text-center align-content-center">
                <p>NEW</p>
                <img :src="editor.thumbnailNew" width="150" height="150" />
                <br>
                <b-button
                    class="mt-2"
                    @click="keepNewMediaThumb"
                    variant="outline-success">
                    {{ $t("media.keep_new_thumb") }}
                </b-button>
              </div>
            </div>
          </div>
          <div class="modalValidLoading" v-show="editor.processingType === 'compress'">
            <vue-ellipse-progress
                v-show="editor.processingType === 'compress'"
                :progress="editor.progressCompress"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#fff"
                :size="70"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>
          <div class="modalValidLoading" v-show="editor.processingType === 'upload'">
            <vue-ellipse-progress
                v-show="editor.processingType === 'upload'"
                :progress="editor.progressUpload"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#fff"
                :size="70"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>
        </div>
      </template>
    </modalMedia>

  </Layout>
</template>

<style>

@import '../../../../node_modules/@pqina/pintura/pintura.css';

  .cursor-pointer {
    cursor:pointer;
  }

  .masonry {
    display: grid;
    grid-gap: 15px;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    grid-auto-rows: 0;
  }

  .bg-female {
    background-color: #f06292;
  }

  .mediaImg {
    max-height: calc(100vh - 100px);
    border-radius: 10px;
    border-top-right-radius-radius:0px;
    border-bottom-right-radius-radius:0px;
  }

  .media-item {
    min-height: 200px !important;
  }

  .media-item input[type="radio"] {
    visibility: hidden;
  }

  .media-item input[type="radio"]+span {
    margin-left:-10px;
  }

  .media-item-content {
    overflow: hidden;
    border-radius: 5px;
    width: 100%;
    background: #F5F5F5;
    box-shadow: 0 0 10px #999;
  }

  .modalValidLoading {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color: rgba(255, 255, 255, .7);
    border-radius: 10px;
  }

  .modalValidLoading > div {
    position: relative;
    width: 100px;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%, -50%);
  }

  .media-item-loading {
    position: absolute;
    top:0;
    right:0;
    bottom: 0;
    left:0;
    text-align: center;
    background-color: rgba(255, 255, 255, .7);
  }

  .media-item-loading i {
    font-size: 60px;
    margin-top: 100px;
  }

  .media-item-content img.media-thumb {
    object-fit: cover;
    width: 100%;
    height: 100%;
    line-height: 0;
    display: block;
    min-height: 50px;
  }

  .b-sidebar-right {
    width:35%;
  }

  .b-sidebar-body {
    padding:16px;
  }

</style>
